import authCheckApp from './authCheckApp'

/**
 * 唤起手机alert弹窗
 * @since 1.0.0
 * @param {Object} obj - 包含了一些弹窗的信息
 * @param {string} obj.message 弹窗中的信息
 * @param {string} obj.title 弹窗的标题
 * @param {string} obj.btnName 按钮名称
 * @example
 * 
 * alert({
 *   message: '弹窗信息',
 *   title: '弹窗标题',
 *   btnName: '按钮名称' 
 * })
 */
function alert(obj) {
    return new Promise((reslove, reject) => {
        authCheckApp()
            .then(() => {
            // 发起请求
                window.WebViewJavascriptBridge.callHandler('alert', {
                    'message': obj.message,
                    'title': obj.title,
                    'btnName': obj.btnName
                }, (response) => {
                    if (typeof response === 'string') {
                        response = JSON.parse(response)
                    }
                    if (response.status === 0) {
                        reslove(response)
                    } else {
                        reject(response)
                    }
                })
            }).catch(err => {
                reject(err)
            })
    })
}

export default alert